// src/components/Beschrijving.js
// Een beschrijving uit Strapi zoals de app hem toont: als blokken, of als markdown voor een waarom-
// of hoe-stuk zonder stappen (die stukken hebben hun opmaak als markdown in de tekst).
import React from 'react';
import { BlocksRenderer } from '@strapi/blocks-react-renderer';
import ReactMarkdown from 'react-markdown';

const alsTekst = (blokken) =>
  blokken
    .map((blok) => (blok.type === 'paragraph' && blok.children ? blok.children.map((kind) => kind.text || '').join('') : ''))
    .join('\n\n');

function Beschrijving({ blokken, markdown }) {
  return markdown ? <ReactMarkdown>{alsTekst(blokken)}</ReactMarkdown> : <BlocksRenderer content={blokken} />;
}

export default Beschrijving;
